import React from 'react';

const IndividualSummary = ({ isView, personalDetails, currentAddress, previousAddress, onEdit, isFreezed }) => {
  return (
    <>
      {!isView && (
        <>
          <div className="text-black text-2xl mt-8 font-normal">Detail summary</div>
          <div className="text-black text-base mt-6">Check the detail below before your add to the process form.</div>
        </>
      )}
      <div className={isView ? 'mt-8' : 'mt-12'}>
        <div className="flex justify-between items-center w-full  gap-6">
          <div className="text-black text-xl font-normal">View Individual details</div>

        </div>

        <div className="flex flex-col md:flex-row gap-6 mt-6">
          <div className="w-full">
            <div className="text-sm text-gray-400 mb-2">First name</div>
            <div className="text-base text-black mb-2">{personalDetails?.firstName || '-'}</div>
          </div>
          <div className="w-full">
            <div className="text-sm text-gray-400 mb-2">Middle name (optional)</div>
            <div className="text-base text-black mb-2">{personalDetails?.middleName || '-'}</div>
          </div>
        </div>
        <div className="flex flex-col md:flex-row gap-6 mt-6">
          <div className="w-full">
            <div className="text-sm text-gray-400 mb-2">Last name</div>
            <div className="text-base text-black mb-2">{personalDetails?.lastName || '-'}</div>
          </div>
          <div className="w-full">
            <div className="text-sm text-gray-400 mb-2">Email</div>
            <div className="text-base text-black mb-2">{personalDetails?.email || '-'}</div>
          </div>
        </div>
      </div>

    </>
  );
};
export default IndividualSummary;
